import { render, staticRenderFns } from "./SocialRedirect.vue?vue&type=template&id=febdbc04&"
import script from "./SocialRedirect.vue?vue&type=script&lang=js&"
export * from "./SocialRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SocialRedirect.vue"
export default component.exports